import { useQuery } from '@tanstack/react-query';
import { useEffect, type ReactNode } from 'react';
import { authApi } from './api';
import { useAuthStore } from './store';
import { isTelegramWebApp, telegramInitData } from './telegram';

export function AuthProvider({ children }: { children: ReactNode }) {
  const { accessToken, setSession, setRights, clear } = useAuthStore();

  // Авто-логин в Telegram WebApp при отсутствии токена
  useEffect(() => {
    if (!accessToken && isTelegramWebApp()) {
      const initData = telegramInitData();
      if (initData) {
        authApi
          .loginTelegram(initData)
          .then((data) => setSession(data))
          .catch(() => {
            // оставим неавторизованным
          });
      }
    }
  }, [accessToken, setSession]);

  // Подгружаем актуальные rights из /me когда есть токен
  const { data: me } = useQuery({
    queryKey: ['auth', 'me'],
    queryFn: authApi.me,
    enabled: !!accessToken,
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (me) {
      setRights(me.rights);
      // обновим user если бэкенд отдал свежее
      if (me.user) {
        useAuthStore.setState({ user: me.user });
      }
    }
  }, [me, setRights]);

  // Если /me вернул 401/404 после tryRefresh не помог → clear
  useEffect(() => {
    // ничего, ApiError сам стрипает токены через client.ts
  }, [clear]);

  return <>{children}</>;
}
